import { IGetRecommendationsNearResponse } from 'shared/common/repositories/newbuilding-search/entities/get_recommendations_near_newbuilding/GetRecommendationsNearResponse';
import {
  IGetRecommendationsNearNewbuildingRequest,
  fetchGetRecommendationsNearNewbuilding,
} from 'shared/common/repositories/newbuilding-search/v1/get-recommendations-near-newbuilding';
import { restApiFunctionWrapper } from 'shared/common/utils/restApiWrapper/restApiWrapper';

export const fetchSimilarNewbuildings = restApiFunctionWrapper<
  IGetRecommendationsNearNewbuildingRequest,
  IGetRecommendationsNearResponse
>(fetchGetRecommendationsNearNewbuilding);
